import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import CryptoJS from 'crypto-js';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { toast } from 'react-toastify';
import SuccessDialog from './SuccessDialog';
import { PayPalButton } from 'react-paypal-button-v2';
import { bucketlink2, serviceId, serverApi } from '../../config/fire-conf';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useRouter } from 'next/router';
import { cyrb53 } from '../../helpers/strToHash';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import {
  collection,
  getDocs,
  getDoc,
  query,
  where,
  doc,
  setDoc,
  Timestamp,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { firebaseFunctions } from '../../config/firebaseFunctions';
import { ref, uploadBytes } from 'firebase/storage';
import { nftFirebaseStorage } from '../../config/firebaseStorage';
import { httpsCallable } from 'firebase/functions';
import { async } from '@firebase/util';
import { Radio } from 'antd';
import { walletID } from '../../config/fire-conf';
import { useDispatch, useSelector } from 'react-redux';
import { getwalletBal } from '../../services/common-query';
import { formatUSDBalance } from '@/services/formatBalance';
import {
  musicartWallet,
  handCashBSVWallet,
  handCashUSDCWallet,
} from '../../config/wallets';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CheckoutDialog(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const userWalletRedux = useSelector((state) => state.walletReducer);
  const userAuthToken = useSelector((state) => state.authReducer.userauthtoken);
  const handCashWalletRedux = useSelector((state) => state.handCashReducer);
  const dispatch = useDispatch();

  const [loading, setloading] = useState(false);
  const [promocodeLoading, setpromocodeLoading] = useState(false);
  const [successDialogState, setsuccessDialogState] = useState(false);
  const [promoCodeField, setpromoCodeField] = useState('');
  const [promoCodeObj, setpromoCodeObj] = useState(null);
  const [issueTxid, setissueTxid] = useState('-');
  const [contractTxid, setcontractTxid] = useState('-');

  const [isAgreedPolicy, setIsAgreedPolicy] = useState(false);
  const [isAgreedTerms, setIsAgreedTerms] = useState(false);
  const [manageNftPath, setmanageNftPath] = useState('');
  const [NftQty, setNftQty] = useState('');
  const [selectedWallet, setselectedWallet] = useState(musicartWallet);

  const [applyPromo, setApplyPromo] = useState(true);
  const [isRendered, setisRendered] = useState(false);

  const router = useRouter();

  useEffect(() => {
    if (!isRendered && props.dialogState) {
      setisRendered(true);
    }
  }, [props.dialogState]);

  const onPolicy = (event) => {
    setIsAgreedPolicy(event.target.checked);
  };

  const onTerms = (event) => {
    setIsAgreedTerms(event.target.checked);
  };

  const handleClose = () => {
    props.setdialogState(false);
    setpromoCodeField('');

    if (promoCodeObj) {
      setpromoCodeObj(null);
      setApplyPromo(true);
    }
  };

  const onSuccessPayment = async (payWithWallet) => {
    setloading(true);

    if (!payWithWallet) {
      toast.info('Minting Nft', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }

    if (!userWalletRedux.addressPath0) {
      toast.error('Wallet address not found, please try again later', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setloading(false);
      return;
    }

    if (!isAgreedPolicy) {
      toast.error('Please agree to the Privacy Policy.', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setloading(false);
      return;
    }
    if (!isAgreedTerms) {
      toast.error('Please agree to the Terms and Conditions.', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setloading(false);
      return;
    }

    try {
      let stasTokenImgArr250 = [];
      let stasTokenImgArr1500 = [];
      let stasTokenImgArr10000 = [];

      let stasTokenImgArr250_full = [];
      let stasTokenImgArr1500_full = [];
      let stasTokenImgArr10000_full = [];

      let fileRefs = [];
      let mintinFeeSet = promoCodeObj
        ? Number(promoCodeObj.discountedPrice)
        : Number(props.nftCreationFee);

      setloading(true);

      if (payWithWallet) {
        if (mintinFeeSet && Number(props.bsvRate)) {
          //converting to BSV
          mintinFeeSet = Number(
            (mintinFeeSet / Number(props.bsvRate)).toFixed(8),
          );
        }

        let walletBalance = userWalletRedux.balance;
        if (selectedWallet === handCashBSVWallet) {
          walletBalance = handCashWalletRedux?.balance[1]?.spendableBalance;
        }
        //  else if (selectedWallet === handCashUSDCWallet) {
        //   walletBalance =
        //     handCashWalletRedux?.balance[0]?.spendableBalance / props.bsvRate;
        //   console.log('walletBalance in bsv', walletBalance);
        // }
        if (payWithWallet && walletBalance < mintinFeeSet) {
          toast.error('Insufficient balance in wallet', {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setloading(false);

          return null;
        }
      }

      await Promise.all(
        props.imageFile.map(async (imgEle, index) => {
          let lstasTokenImg250;
          let lstasTokenImg1500;
          let lstasTokenImg10000;

          let imageId = uuidv4();

          if (
            imgEle.type === 'image/gif' ||
            imgEle.type === 'video/mp4' ||
            imgEle.type.includes('audio')
          ) {
            let itemLink;
            if (imgEle.type === 'image/gif') {
              fileRefs.push(`nftAssetsGif/${imageId}.gif`);
              itemLink = `${bucketlink2}nftAssetsGif%2F${imageId}.gif?alt=media`;
            } else if (imgEle.type.includes('audio')) {
              fileRefs.push(`nftAssets/${imageId}_audio`),
                (itemLink = `${bucketlink2}nftAssets%2F${imageId}_audio?alt=media`);
            } else {
              fileRefs.push(`nftAssets/${imageId}_video`),
                (itemLink = `${bucketlink2}nftAssets%2F${imageId}_video?alt=media`);
            }
            stasTokenImgArr250.push(itemLink);
            stasTokenImgArr1500.push(itemLink);
            stasTokenImgArr10000.push(itemLink);
          } else {
            fileRefs.push(`nftAssets/${imageId}`);
            lstasTokenImg250 = `${bucketlink2}nftAssets%2F${imageId}_250x250?alt=media`;
            stasTokenImgArr250.push(lstasTokenImg250);

            lstasTokenImg1500 = `${bucketlink2}nftAssets%2F${imageId}_1500x1500?alt=media`;
            stasTokenImgArr1500.push(lstasTokenImg1500);

            lstasTokenImg10000 = `${bucketlink2}nftAssets%2F${imageId}_10000x10000?alt=media`;
            stasTokenImgArr10000.push(lstasTokenImg10000);
          }
          let uploadTask = ref(nftFirebaseStorage, fileRefs[index]);

          await uploadBytes(uploadTask, imgEle.originFileObj);

          // setDoc(doc(firebaseFireStore, 'mediaHash', hashedList[index]), {
          //   date: Timestamp.now(),
          //   uid: userDataRedux.uid,
          //   stasTokenImgArr250: stasTokenImgArr250[index],
          //   stasTokenImgArr1500: stasTokenImgArr1500[index],
          //   stasTokenImgArr10000: stasTokenImgArr10000[index],
          // });
        }),
      );

      //uploading full images
      await Promise.all(
        props.imageFullFile.map(async (imgEle, index) => {
          let lstasTokenImg250_full;
          let lstasTokenImg1500_full;
          let lstasTokenImg10000_full;

          let imageId = uuidv4() + '_full';
          let fileRef;

          if (
            imgEle.type === 'image/gif' ||
            imgEle.type === 'video/mp4' ||
            imgEle.type.includes('audio')
          ) {
            console.log('1111111', stasTokenImgArr250[index]);
            // let itemLink;
            // if (imgEle.type === 'image/gif') {
            //   fileRef = `nftAssetsGif/${imageId}.gif`;
            //   itemLink = `${bucketlink2}nftAssetsGif%2F${imageId}.gif?alt=media`;
            // } else if (imgEle.type.includes('audio')) {
            //   (fileRef = `nftAssets/${imageId}_audio`),
            //     (itemLink = `${bucketlink2}nftAssets%2F${imageId}_audio?alt=media`);
            // } else {
            //   (fileRef = `nftAssets/${imageId}_video`),
            //     (itemLink = `${bucketlink2}nftAssets%2F${imageId}_video?alt=media`);
            // }
            // stasTokenImgArr250_full.push(itemLink);
            // stasTokenImgArr1500_full.push(itemLink);
            // stasTokenImgArr10000_full.push(itemLink);

            stasTokenImgArr250_full.push(stasTokenImgArr250[index]);
            stasTokenImgArr1500_full.push(stasTokenImgArr1500[index]);
            stasTokenImgArr10000_full.push(stasTokenImgArr10000[index]);
          } else {
            fileRef = `nftAssets/${imageId}`;
            lstasTokenImg250_full = `${bucketlink2}nftAssets%2F${imageId}_250x250?alt=media`;
            stasTokenImgArr250_full.push(lstasTokenImg250_full);

            lstasTokenImg1500_full = `${bucketlink2}nftAssets%2F${imageId}_1500x1500?alt=media`;
            stasTokenImgArr1500_full.push(lstasTokenImg1500_full);

            lstasTokenImg10000_full = `${bucketlink2}nftAssets%2F${imageId}_10000x10000?alt=media`;
            stasTokenImgArr10000_full.push(lstasTokenImg10000_full);

            let uploadTask = ref(nftFirebaseStorage, fileRef);
            await uploadBytes(uploadTask, imgEle.originFileObj);
          }
        }),
      );

      const tokenDetails = { ...props.nftDetails };

      //cropped images
      tokenDetails.stasTokenImgArr250 = stasTokenImgArr250;
      tokenDetails.stasTokenImgArr1500 = stasTokenImgArr1500;
      tokenDetails.stasTokenImgArr10000 = stasTokenImgArr10000;

      //full images
      tokenDetails.stasTokenImgArr250_full = stasTokenImgArr250_full;
      tokenDetails.stasTokenImgArr1500_full = stasTokenImgArr1500_full;
      tokenDetails.stasTokenImgArr10000_full = stasTokenImgArr10000_full;

      //audio check
      if (tokenDetails.nftType === 'Audio') {
        // encrypting file
        let encryptedFiles = [];
        let encryptionKey = uuidv4();

        let shaKey = CryptoJS.SHA256(
          encryptionKey + tokenDetails.tokenId,
        ).toString();

        await Promise.all(
          props.imageFile.map(async (fileEle, fileIndex) => {
            let file = fileEle.originFileObj;
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = async (e) => {
                try {
                  var wordArray = CryptoJS.lib.WordArray.create(reader.result); // Convert: ArrayBuffer -> WordArray
                  var encrypted = CryptoJS.AES.encrypt(
                    wordArray,
                    shaKey,
                  ).toString(); // Encryption: I: WordArray -> O: -> Base64 encoded string (OpenSSL-format)

                  var fileEnc = new Blob([encrypted]); // Create blob from string

                  let fileId = uuidv4();
                  console.log('getting path', bucketlink2, fileId);
                  let path = `${bucketlink2}encryptedFiles%2F${fileId}?alt=media`;
                  console.log('path', path);
                  encryptedFiles[fileIndex] = path;
                  let uploadTask = ref(
                    nftFirebaseStorage,
                    `encryptedFiles/${fileId}`,
                  );
                  await uploadBytes(uploadTask, fileEnc);

                  resolve(true);
                } catch (err) {
                  reject(err);
                }
              };

              reader.readAsArrayBuffer(file);
            });
          }),
        );

        console.log('encryptedFiles', encryptedFiles);

        let sampleAudioFileID = uuidv4();
        let sampleAudioFileUrl = `${bucketlink2}nftAssets%2F${sampleAudioFileID}_audio?alt=media`;

        let uploadTask1 = ref(
          nftFirebaseStorage,
          `nftAssets/${sampleAudioFileID}_audio`,
        );
        await uploadBytes(uploadTask1, props.sampleAudioFile[0].originFileObj);

        //cover
        let audioCoverFileUrl250 = [];
        let audioCoverFileUrl1500 = [];
        let audioCoverFileUrl10000 = [];
        await Promise.all(
          props.audioCoverFile.map(async (imgEle, index) => {
            let lstasTokenImg250;
            let lstasTokenImg1500;
            let lstasTokenImg10000;

            let imageId = uuidv4();
            let fileRefs = `nftAssets/${imageId}_cover`;

            if (imgEle.type === 'image/gif') {
              lstasTokenImg250 = `${bucketlink2}nftAssets%2F${imageId}_cover?alt=media`;
              audioCoverFileUrl250.push(lstasTokenImg250);

              lstasTokenImg1500 = `${bucketlink2}nftAssets%2F${imageId}_cover?alt=media`;
              audioCoverFileUrl1500.push(lstasTokenImg1500);

              lstasTokenImg10000 = `${bucketlink2}nftAssets%2F${imageId}_cover?alt=media`;
              audioCoverFileUrl10000.push(lstasTokenImg10000);
            } else {
              lstasTokenImg250 = `${bucketlink2}nftAssets%2F${imageId}_cover_250x250?alt=media`;
              audioCoverFileUrl250.push(lstasTokenImg250);

              lstasTokenImg1500 = `${bucketlink2}nftAssets%2F${imageId}_cover_1500x1500?alt=media`;
              audioCoverFileUrl1500.push(lstasTokenImg1500);

              lstasTokenImg10000 = `${bucketlink2}nftAssets%2F${imageId}_cover_10000x10000?alt=media`;
              audioCoverFileUrl10000.push(lstasTokenImg10000);
            }
            let uploadTask = ref(nftFirebaseStorage, fileRefs);
            await uploadBytes(uploadTask, imgEle.originFileObj);
          }),
        );

        //cover full
        let audioCoverFileUrl250Full = [];
        let audioCoverFileUrl1500Full = [];
        let audioCoverFileUrl10000Full = [];

        await Promise.all(
          props.audioCoverFileFull.map(async (imgEle, index) => {
            let lstasTokenImg250Full;
            let lstasTokenImg1500Full;
            let lstasTokenImg10000Full;

            let imageId = uuidv4();
            let fileRefs = `nftAssets/${imageId}_cover`;

            if (imgEle.type === 'image/gif') {
              audioCoverFileUrl250Full.push(audioCoverFileUrl250[index]);
              audioCoverFileUrl1500Full.push(audioCoverFileUrl1500[index]);
              audioCoverFileUrl10000Full.push(audioCoverFileUrl10000[index]);
            } else {
              lstasTokenImg250Full = `${bucketlink2}nftAssets%2F${imageId}_cover_250x250?alt=media`;
              audioCoverFileUrl250Full.push(lstasTokenImg250Full);

              lstasTokenImg1500Full = `${bucketlink2}nftAssets%2F${imageId}_cover_1500x1500?alt=media`;
              audioCoverFileUrl1500Full.push(lstasTokenImg1500Full);

              lstasTokenImg10000Full = `${bucketlink2}nftAssets%2F${imageId}_cover_10000x10000?alt=media`;
              audioCoverFileUrl10000Full.push(lstasTokenImg10000Full);

              let uploadTask = ref(nftFirebaseStorage, fileRefs);
              await uploadBytes(uploadTask, imgEle.originFileObj);
            }
          }),
        );

        let audioDurationArr = [];
        await Promise.all(
          props.imageFile.map(async (fileEle, fileIndex) => {
            let file = fileEle.originFileObj;

            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              let audio = document.createElement('audio');
              reader.onload = async (e) => {
                try {
                  audio.currentTime = 24 * 60 * 60;
                  audio.volume = 0;

                  audio.src = e.target.result;
                  console.log('duration 00', audio.readyState);

                  audio.addEventListener(
                    'durationchange',
                    function () {
                      var duration = audio.duration;
                      if (duration !== Infinity) {
                        console.log('duration new', duration);
                        duration = moment
                          .utc(duration * 1000)
                          .format('HH:mm:ss');

                        audioDurationArr[fileIndex] = duration.replace(
                          /^0(?:0:0?)?/,
                          '',
                        );
                        resolve(true);
                      }
                    },
                    false,
                  );

                  // audio.addEventListener(
                  //   'loadedmetadata',
                  //   function () {
                  //     var duration = audio.duration;
                  //     console.log('duration tt', duration);
                  //     duration = moment.utc(duration * 1000).format('HH:mm:ss');

                  //     audioDurationArr[fileIndex] = duration.replace(
                  //       /^0(?:0:0?)?/,
                  //       '',
                  //     );
                  //     resolve(true);
                  //   },
                  //   false,
                  // );
                } catch (err) {
                  reject(err);
                }
              };

              reader.readAsDataURL(file);
            });
          }),
        );

        tokenDetails.sampleAudioFile = sampleAudioFileUrl;
        tokenDetails.audioCoverFile250 = audioCoverFileUrl250;
        tokenDetails.audioCoverFile1500 = audioCoverFileUrl1500;
        tokenDetails.audioCoverFile10000 = audioCoverFileUrl10000;

        tokenDetails.audioCoverFile250_full = audioCoverFileUrl250Full;
        tokenDetails.audioCoverFile1500_full = audioCoverFileUrl1500Full;
        tokenDetails.audioCoverFile10000_full = audioCoverFileUrl10000Full;

        tokenDetails.audioFilesDuration = audioDurationArr;
        tokenDetails.audioFileNames = props.audioFileNames;
        tokenDetails.encryptedFiles = encryptedFiles;
        tokenDetails.encryptionKey = encryptionKey;
      }

      tokenDetails.date = Number(moment().format('x'));
      tokenDetails.visibility = false;
      tokenDetails.userId = userDataRedux.uid;
      tokenDetails.adminState = 'ACCEPT';
      tokenDetails.price = Number(tokenDetails.price);
      tokenDetails.minBiddingPrice = Number(tokenDetails.minBiddingPrice);
      tokenDetails.nftQuantity = Number(tokenDetails.nftQuantity);
      tokenDetails.royalty = Number(tokenDetails.royalty);
      tokenDetails.collection =
        tokenDetails.collection && tokenDetails.collection !== ''
          ? tokenDetails.collection
          : 'NA';
      tokenDetails.issuerName =
        userDataRedux && userDataRedux.displayName
          ? userDataRedux.displayName
          : '-';

      let nftIssuanceAPI;

      if (payWithWallet) {
        nftIssuanceAPI = httpsCallable(
          firebaseFunctions,
          'musicartNftIssuanceWithFee',
        );
      } else {
        nftIssuanceAPI = httpsCallable(
          firebaseFunctions,
          'musicartNftIssuance',
        );
      }
      let resObj = {
        tokenDetails: tokenDetails,
        destinationAddress: userWalletRedux.addressPath0,
        userAuthToken: userAuthToken,
      };
      if (payWithWallet) {
        resObj.fee = mintinFeeSet;
        resObj.wallet = selectedWallet;
      }

      let res;
      console.log('resObj', resObj);
      res = await nftIssuanceAPI(resObj);

      // res = await issueNft(
      //   resObj.tokenDetails,
      //   resObj.destinationAddress,
      //   userDataRedux.uid,
      //   resObj.userAuthToken
      // );

      console.log('res', res);

      if (res?.data && res.data.status === 'success') {
        // props.imageFile.map((imgEle, indx) => {
        //   console.log(stasTokenImgArr1500[indx]);
        //   setDoc(doc(firebaseFireStore, 'mediaHash', hashedList[indx]), {
        //     date: Timestamp.now(),
        //     uid: userDataRedux.uid,
        //     stasTokenImgArr250: stasTokenImgArr250[indx],
        //     stasTokenImgArr1500: stasTokenImgArr1500[indx],
        //     stasTokenImgArr10000: stasTokenImgArr10000[indx],
        //   });
        // });

        if (res?.data?.issueTxid) {
          setissueTxid(res.data.issueTxid);
        }
        if (res?.data?.contractTxid) {
          setcontractTxid(res.data.contractTxid);
        }
        if (res?.data && res.data.tokenId) {
          setmanageNftPath(res.data.tokenId);
          setNftQty(tokenDetails.nftQuantity);
        }

        toast.success(res?.data?.msg, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        //updating wallet balance
        getwalletBal(walletID, dispatch);

        props.setnftDetails({
          schemaId: 'Schema STAS Coupon',
          tokenName: '', //title
          tokenId: '',
          tokenDescription: '',
          terms:
            'Each MusicArt NFT is a digital token that represents your ownership of that particular item (which will continue until you sell or transfer it to somebody else). Your ownership of the MusicArt NFT will be forever associated with that item even after you transfer or sell it, as part of the permanent ledger of ownership that will follow that item. Please note that ownership of a MusicArt NFT does not bestow ownership in the intellectual property underlying the MusicArt NFT, other than the limited license that is granted to you via your purchase (which does not contain any rights to make any commercial use of the MusicArt NFT or any element therein, including without limitation by selling copies or derivative or merchandised works based on or associated with the MusicArt NFT in any media). The limited rights granted to you will end upon sale or transfer of the MusicArt NFT. Your ownership is of only the MusicArt NFT, not the underlying artwork and such ownership gives you no right to do anything which might disparage the original artist’s reputation, or advertise or promote any other item or service, or use or display the MusicArt NFT in a manner that associates any other product or service with the MusicArt NFT or the original artist. The original Artist reserves all intellectual property rights in the MusicArt NFT, including without limitation the right to copy, create derivative art works, display, perform, and/or distribute the MusicArt NFT.',
          governingLaw: 'Cayman Islands Law',
          tickerSymbol: '',
          price: '',
          activeInMarketPlace: false,
          category: 'Sleeve',
          thumbnailDesc: '',
          nftQuantity: 1,
          isMultiple: false,
          nftSaleType: 'SalePrice', //SalePrice, Auctioning
          minBiddingPrice: '',
          auctionTimePeriod: '24h',
          royalty: '10',
          musicArtist: '',
          collection: '',
          artistId: null,
          artistName: '',
        });
        props.setimagesUploadData({
          stasTokenImgArr250_full: [],
          stasTokenImgArr1500_full: [],
          stasTokenImgArr10000_full: [],
        });

        props.setimageFile([]);
        props.setaudioFileNames([]);
        props.setimageFullFile([]);

        setpromoCodeField('');
        setpromoCodeObj(null);
        setloading(false);

        handleClose();
        setsuccessDialogState(true);
      } else {
        toast.error(res?.data?.msg, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setloading(false);
      }
    } catch (err) {
      console.log('catch err', err);
      toast.error(err.message, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });

      setloading(false);
    }
  };

  const applyPromoCode = async (e) => {
    e.preventDefault();
    setpromocodeLoading(true);

    const q = query(
      collection(firebaseFireStore, 'MusicArtAdminPromoCodes'),
      where('promoCode', '==', promoCodeField),
    );

    try {
      let dbRef = await getDocs(q);

      if (dbRef.empty) {
        toast.error('Promo Code not found!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      }

      if (!applyPromo) {
        //false
        toast.error('Promo Code already applied!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      }

      let dataArr = [];
      dbRef.forEach((doc) => {
        dataArr.push(doc.data());
      });

      if (dataArr.length === 0 || !dataArr[0]) {
        toast.error('Promo Code not found!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      }

      //valid promocode
      let lobj = dataArr[0];

      let cTime = Number(moment().format('x'));
      if (cTime > Number(lobj.endTimestamp)) {
        toast.error('Promo Code has been expired!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      } else if (cTime < Number(lobj.startTimestamp)) {
        toast.error('Promo Code not found!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      }

      // console.log("lobj", lobj);

      let discount;
      if (lobj.type === 'PERCENTAGE') {
        if (
          // props.isMultiple &&
          Number(lobj.maxLimit) < Number(props.nftDetails.nftQuantity)
        ) {
          let feeToBeDiscounted = props.nftSetupFee + Number(lobj.maxLimit) - 1;
          discount = (Number(feeToBeDiscounted) * Number(lobj.value)) / 100;
        } else {
          discount = (Number(props.nftCreationFee) * Number(lobj.value)) / 100;
        }
      } else {
        discount = Number(lobj.value) * Number(props.bsvRate); //in bsv to $

        if (
          // props.isMultiple &&
          Number(lobj.maxLimit) < Number(props.nftDetails.nftQuantity)
        ) {
          let feeToBeDiscounted = props.nftSetupFee + Number(lobj.maxLimit) - 1;
          if (discount >= Number(feeToBeDiscounted)) {
            discount = Number(feeToBeDiscounted);
          }
        } else {
          if (discount >= Number(props.nftCreationFee)) {
            discount = Number(props.nftCreationFee);
          }
        }
      }
      toast.success('Promo Code applied', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
      setpromoCodeObj({
        ...lobj,
        discountAmount: discount,
        discountedPrice: Number(props.nftCreationFee) - Number(discount),
      });
      setApplyPromo(false);
      setpromocodeLoading(false);
    } catch (err) {
      setpromocodeLoading(false);
      // console.log("catch err", err);
      toast.error(err.message, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  return (
    <>
      <Dialog
        open={props.dialogState}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            overflowX: 'hidden',
            borderRadius: 20,
            width: 380,
          },
        }}
        disableScrollLock={false}
        style={{ zIndex: 999 }}
        maxWidth="sm"
        onClose={handleClose}
      >
        <div>
          <div className="dialog-titlebar">
            <div className="dialog-title">Checkout</div>
            <div className="dialog-close">
              <button
                className={`bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300 closeButton`}
                type="button"
                onClick={() => {
                  if (!loading) {
                    handleClose();
                    setApplyPromo(true);
                  }
                }}
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div>
            <DialogContent>
              <div>
                <div className="py-3">
                  <label className="text-black text-base font-medium mb-4">
                    You are about to mint a new NFT
                  </label>
                </div>
                <div className="py-3 border-b">
                  <label className="text-gray-500">
                    NFT setup fee (BSV{' '}
                    {props.nftCreationFee &&
                      (
                        Number(props.nftCreationFee) / Number(props.bsvRate)
                      ).toFixed(4)}
                    )
                  </label>
                  <label className="float-right">
                    {props.nftCreationFee} $
                  </label>
                </div>

                {promoCodeObj && (
                  <div className="py-2">
                    <label className="text-gray-500">Promo Code</label>
                    <label className="float-right">
                      <span
                        className="link ml-2"
                        onClick={() => {
                          setpromoCodeObj(null);
                          setApplyPromo(true);
                        }}
                      >
                        -
                      </span>{' '}
                      ({Number(promoCodeObj.discountAmount).toFixed(2)}) $
                    </label>
                  </div>
                )}

                <div className="py-2">
                  <label className="text-gray-500">
                    You will pay (BSV{' '}
                    {promoCodeObj
                      ? (
                          Number(promoCodeObj.discountedPrice) /
                          Number(props.bsvRate)
                        ).toFixed(4)
                      : (
                          Number(props.nftCreationFee) / Number(props.bsvRate)
                        ).toFixed(4)}
                    )
                  </label>
                  <label className="float-right">
                    {promoCodeObj
                      ? Number(promoCodeObj.discountedPrice).toFixed(2)
                      : props.nftCreationFee}{' '}
                    $
                  </label>
                </div>
                <div className="py-2">
                  <form
                    onSubmit={applyPromoCode}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        position: 'relative',
                        // border: "2px solid red",
                        overflow: 'hidden',
                      }}
                    >
                      <input
                        className="promo_input_box"
                        type="text"
                        placeholder="Promo code"
                        style={{
                          height: 30,
                          width: 150,
                        }}
                        value={promoCodeField}
                        onChange={(e) => {
                          setpromoCodeField(e.target.value);
                        }}
                        required
                      />
                      {promoCodeField && promoCodeField.length > 0 && (
                        <button
                          type="button"
                          onClick={() => {
                            setpromoCodeField('');
                            setpromoCodeObj(null);
                            setApplyPromo(true);
                          }}
                          className="close_icon"
                          style={{
                            bottom: 5,
                            right: 5,
                            height: 'auto',
                          }}
                        >
                          <HighlightOffIcon />
                        </button>
                      )}
                    </div>
                    <div className="text-gray-500 ml-2" style={{ width: 100 }}>
                      {promocodeLoading ? (
                        <div className="block">
                          <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                        </div>
                      ) : (
                        <button
                          className="link link_text text_in_one_line"
                          type="submit"
                        >
                          Apply Code
                        </button>
                      )}
                    </div>
                  </form>
                </div>
                <div className="sign__group sign__group--checkbox">
                  <input
                    id="isAgreedPolicy"
                    name="isAgreedPolicy"
                    type="checkbox"
                    onChange={onPolicy}
                    checked={isAgreedPolicy}
                  />
                  <label htmlFor="isAgreedPolicy">
                    I have read and agree to the&nbsp;
                    <a href="/privacy-policy" target="_blank">
                      Privacy Policy.
                    </a>
                  </label>
                </div>
                <div className="sign__group sign__group--checkbox">
                  <input
                    id="isAgreedTerms"
                    name="isAgreedTerms"
                    type="checkbox"
                    onChange={onTerms}
                    checked={isAgreedTerms}
                  />
                  <label htmlFor="isAgreedTerms">
                    I have read and agree to the&nbsp;
                    <a href="/terms-of-service" target="_blank">
                      Terms of Service.
                    </a>
                  </label>
                </div>
              </div>
            </DialogContent>
            <DialogActions
              style={{
                paddingTop: 15,
                paddingBottom: 10,
                justifyContent: 'center',
                boxSizing: 'border-box',
                flexDirection: 'column',
              }}
            >
              <div></div>
              <Radio.Group
                onChange={(e) => {
                  setselectedWallet(e.target.value);
                }}
                value={selectedWallet}
                style={{ width: '100%' }}
                className="mb-6"
              >
                <div className="w-full px-4 mb-2">
                  <button
                    className={`wallet_sel_dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full ${
                      selectedWallet === musicartWallet
                        ? 'wallet_selected_dialog__btn'
                        : ''
                    }`}
                    type="button"
                    onClick={() => setselectedWallet(musicartWallet)}
                    style={{ textTransform: 'none' }}
                  >
                    <div
                      className="flex align-center"
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <div>
                        {' '}
                        MusicArt Wallet (BSV)
                        <br />
                        Balance:{' '}
                        {userWalletRedux && userWalletRedux.balance
                          ? userWalletRedux.balance.toFixed(4)
                          : 0}{' '}
                        BSV ($
                        {props.bsvRate &&
                        userWalletRedux &&
                        userWalletRedux.balance
                          ? formatUSDBalance(
                              userWalletRedux.balance * props.bsvRate,
                            )
                          : 0}
                        )
                      </div>
                      <div style={{ position: 'absolute', right: 0 }}>
                        <Radio value={musicartWallet}> </Radio>
                      </div>
                    </div>
                  </button>
                </div>
                {handCashWalletRedux?.balance &&
                  handCashWalletRedux?.balance[1] && (
                    <div className="w-full px-4 mb-2">
                      <button
                        className={`wallet_sel_dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full ${
                          selectedWallet === handCashBSVWallet
                            ? 'wallet_selected_dialog__btn'
                            : ''
                        }`}
                        type="button"
                        onClick={() => setselectedWallet(handCashBSVWallet)}
                        style={{ textTransform: 'none' }}
                      >
                        <div>
                          {' '}
                          HandCash Wallet (BSV)
                          <br />
                          Balance:{' '}
                          {handCashWalletRedux?.balance[1]?.spendableBalance
                            ? handCashWalletRedux.balance[1].spendableBalance.toFixed(
                                4,
                              )
                            : 0}{' '}
                          BSV ($
                          {props.bsvRate &&
                          handCashWalletRedux?.balance[1]?.spendableBalance
                            ? (
                                handCashWalletRedux.balance[1]
                                  .spendableBalance * props.bsvRate
                              ).toFixed(2)
                            : 0}
                          )
                        </div>
                        <div style={{ position: 'absolute', right: 0 }}>
                          <Radio value={handCashBSVWallet}> </Radio>
                        </div>
                      </button>
                    </div>
                  )}
                {/* {handCashWalletRedux?.balance &&
                  handCashWalletRedux?.balance[0] && (
                    <div className="w-full px-4 ">
                      <button
                        className={`wallet_sel_dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full ${
                          selectedWallet === handCashUSDCWallet
                            ? 'wallet_selected_dialog__btn'
                            : ''
                        }`}
                        type="button"
                        onClick={() => setselectedWallet(handCashUSDCWallet)}
                        style={{ textTransform: 'none' }}
                      >
                        <div>
                          {' '}
                          HandCash Wallet (USDC)
                          <br />
                          Balance:{' '}
                          {handCashWalletRedux?.balance[0]?.spendableBalance
                            ? handCashWalletRedux.balance[0].spendableBalance
                            : 0}{' '}
                          USDC ($
                          {handCashWalletRedux?.balance[0]?.spendableBalance
                            ? handCashWalletRedux.balance[0].spendableBalance
                            : 0}
                          )
                        </div>
                        <div style={{ position: 'absolute', right: 0 }}>
                          <Radio value={handCashUSDCWallet}> </Radio>
                        </div>
                      </button>
                    </div>
                  )} */}
              </Radio.Group>

              {(() => {
                if (loading) {
                  return (
                    <div className="flex justify-center	w-full mb-6">
                      <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                    </div>
                  );
                } else {
                  return (
                    <>
                      <div className="w-full px-4">
                        <button
                          className="dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full"
                          type="button"
                          onClick={() => onSuccessPayment(true)}
                        >
                          Pay with wallet
                        </button>
                      </div>

                      <div>
                        <p className="text-gray-500 my-4">or</p>
                      </div>

                      <div className="w-full px-4 ">
                        {isRendered && (
                          <PayPalButton
                            amount={
                              promoCodeObj
                                ? Number(promoCodeObj.discountedPrice).toFixed(
                                    2,
                                  )
                                : Number(props.nftCreationFee)
                            }
                            options={{
                              clientId:
                                'AQrugS77uhKmmv5VO68CIQOm1JkRgZaIr83w5_iUxJp197GsDnnsAIzsnkbdqO9aTPW1dDvmGoOaHWix',
                            }}
                            onSuccess={(details, data) => {
                              console.log('success', details, data);
                              return onSuccessPayment(false);
                            }}
                            onError={(err) => {
                              console.log('on paypal err');
                              // toast.error('Paypal transaction failed.', {
                              //   position: 'bottom-left',
                              //   autoClose: 1000,
                              //   hideProgressBar: false,
                              //   closeOnClick: true,
                              //   pauseOnHover: true,
                              //   draggable: true,
                              // });
                            }}
                            onCancel={(err) => {
                              console.log('on paypal cancel');
                              toast.error('Paypal transaction cancelled.', {
                                position: 'bottom-left',
                                autoClose: 1000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                              });
                            }}
                            catchError={(err) => {
                              console.log('on paypal catch err');
                              toast.error('Something went wrong with Paypal.', {
                                position: 'bottom-left',
                                autoClose: 1000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                              });
                            }}
                          />
                        )}
                      </div>
                    </>
                  );
                }
              })()}
            </DialogActions>
          </div>
        </div>
      </Dialog>
      <SuccessDialog
        dialogState={successDialogState}
        setdialogState={setsuccessDialogState}
        issueTxid={issueTxid}
        contractTxid={contractTxid}
        manageNftPath={manageNftPath}
        NftQty={NftQty}
      />
    </>
  );
}
